<template>
    <ion-page >




        <ion-content style="height: 100%; overflow-y: auto; padding-top: 56px;">
            <!-- Adjust padding-top to ensure content is not blocked by the header -->



            <ion-item>
                <div>
                    <b>
                        <h1 style="left:10px;text-align: center;">Why Choose Atlantis Electrical Systems</h1>
                    </b>
                    <div>
                        <h3>
                            Expertise & Certifications

                        </h3>
                        <p style="color:#1C8AF7">
                            We’re proud to employ a team of industry-certified professionals that are BICSI RCDDs, and
                            BICSI Technicians bringing years of real-world experience to
                            every job. They’re committed to mastering the latest industry standards and technologies.
                        </p>
                    </div>
                    <div>
                        <h3>
                            Tailored Solutions for Every Sector
                        </h3>
                        <p style="color:#1C8AF7">
                            From high-stakes commercial projects to government facilities, educational institutions
                            (K‑12 through higher ed), healthcare, industrial environments, and beyond, we deliver
                            customized solutions in:
                        <ul>
                            <li>Low‑voltage systems & Data Cabling</li>
                            <li>Structured cabling & Fiber optics</li>
                            <li>Audio‑visual & communications integrations</li>
                        </ul>
                        </p>
                    </div>
                    <div>
                        <h3>
                            Unmatched Reliability & Quality


                        </h3>
                        <p style="color:#1C8AF7">
                            As a licensed specialty contractor based in Melbourne/Palm Bay, FL, we serve the Heart of
                            Brevard County with proven dependability and professionalism. Whether your project demands
                            rapid turnaround or ultra‑precise execution, we deliver with
                            integrity.
                        </p>
                    </div>
                </div>
            </ion-item>
            <ion-item>
                <div>
                    <h1>Why Choose Atlantis Electrical Systems</h1>
                    <p style="color:#1C8AF7; margin-right:20vw">All of our Electricians and Data-Comm Technicians
                        possess years of
                        on the job experience. Not only that, but they're also industry certified and committed to
                        keeping up with
                        the
                        latest advances in the field. You can rest easy because your electrical job will be in the best
                        and most
                        skilled hands that it can be.</p>

                </div>
                <ion-img style="width:20vw; height: auto;" :src="bicsiLogo" alt="BICSI Logo" slot="end" />

            </ion-item>
            <ion-item>
                <div>
                    <h1>Services We Provide</h1>
                    <p style="color:#1C8AF7; margin-right:20vw">
                    <ul></ul>
                    <li><b>Low‑Voltage Installations</b> – Data/voice cabling, BICSI‑grade structured systems</li>
                    <li><b>Data‑Comm & Fiber Optic Cabling</b> – Local area network builds, backbone installations </li>
                    <li><b>Audio‑Visual & Communications</b> – Conference rooms, digital signage, intercoms</li>
                    <li><b>Preventive Maintenance & Service</b> – Regular check‑ups, upgrades, and troubleshooting</li>
                    </p>
                </div>


            </ion-item>
            <ion-item>
                <div>
                    <h1>Our Promises</h1>
                    <p style="color:#1C8AF7; margin-right:20vw">
                    <ul></ul>
                    <li><b>Certified technicians</b> using cutting‑edge tools & tech</li>
                    <li><b>Clear communication</b> and transparent project management</li>
                    <li><b>Strict adherence</b> to code, schedule, and safety standards</li>
                    <li><b>100% client satisfaction</b>—we build trust through performance</li>
                    </p>
                </div>

            </ion-item>
            <ion-item>
                <div>
                    <h1>Serving Brevard County, FL</h1>
                    <p style="color:#1C8AF7; margin-right:20vw">Proudly based in Melbourne and Palm Bay at:<b><i>1451
                                Clearmont St NE, Palm Bay, Florida</i></b></p>
                    <p> <iframe width="250" height="150" style="border:0" loading="lazy" allowfullscreen
                            referrerpolicy="no-referrer-when-downgrade" src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDUC3fo_kepojey05LIk6MQ3FSOyrjrOxM
    &q=1451+Clearmont+St+NE,+Palm+Bay,+FL+32905">
                        </iframe></p>
                </div>
                <div style="display: flex; flex-direction: column; align-items: center;">
                    <p style="color:#1C8AF7; margin-bottom:5vh"><b>Ready to elevate your project with our expertise?
                            Let’s
                            connect!</b></p>
                    <a style="cursor: pointer;" @click="$router.push('/projects')"><u>Take a look at some of our
                            previous projects</u></a>
                    <ion-button size="large" @click="$router.push('/requestquote/div27')">
                        Request a Quote
                    </ion-button>
                </div>
            </ion-item>
        </ion-content>
    </ion-page>
</template>

<script setup lang="ts">
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonImg, IonButton } from '@ionic/vue';

import { ref } from 'vue';

const bicsiLogo = "https://aes-site-assets.pages.dev/homepage/bicsi.png";




</script>
